module.exports = __webpack_public_path__ + "static/media/tv-retro.92a6a5aa.svg";